const LABELS = ["Package", "When", "Where", "Review"];

export default function BookingStepper({ step }) {
  return (
    <div className="flex items-center gap-2 mb-10" data-testid="stepper">
      {[1, 2, 3, 4].map((n) => (
        <div key={n} className="flex-1 flex items-center gap-2">
          <div className={`flex items-center gap-2 ${step >= n ? "text-forest" : "text-muted2/60"}`}>
            <span
              className={`w-7 h-7 rounded-full text-xs flex items-center justify-center border ${
                step >= n ? "bg-forest text-white border-forest" : "border-black/15"
              }`}
            >{n}</span>
            <span className="text-xs uppercase tracking-[0.18em] hidden sm:inline">
              {LABELS[n - 1]}
            </span>
          </div>
          {n < 4 && <div className={`flex-1 h-px ${step > n ? "bg-forest" : "bg-black/10"}`} />}
        </div>
      ))}
    </div>
  );
}
